import { render, staticRenderFns } from "./AuthorRegist.vue?vue&type=template&id=d2ac3842&scoped=true"
import script from "./AuthorRegist.vue?vue&type=script&lang=js"
export * from "./AuthorRegist.vue?vue&type=script&lang=js"
import style0 from "./AuthorRegist.vue?vue&type=style&index=0&id=d2ac3842&prod&lang=css"
import style1 from "./AuthorRegist.vue?vue&type=style&index=1&id=d2ac3842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ac3842",
  null
  
)

export default component.exports